module.exports = __webpack_public_path__ + "static/media/uoa-20.f4f5e06b.jpg";